export const afterQueueAnimation = (store, cb) => {
  const getRunning = () => store.getters["popups/getQueueAnimationIsRunning"];
  let started = getRunning();
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    unwatch();
    clearTimeout(fallback);
    cb();
  };
  const unwatch = store.watch(getRunning, (running) => {
    if (running) started = true;
    else if (started) finish();
  });
  const fallback = setTimeout(() => {
    if (!started) finish();
  }, 1500);
};
